<div class="container-fluid">
  <div class="rcr-exchange-error" *ngIf="!isRCRFLOW">
    <div
      class="message-container text-alignment"
      [ngClass]="{
        'message-container--error': modalHasStatusError,
        'message-container--success': modalHasStatusSuccess,
      }"
    >
      <span class="status-icon">
        <ng-container *ngIf="modalHasStatusError">
          <i class="fa fa-ban status-icon--md"></i>
        </ng-container>
        <ng-container *ngIf="modalHasStatusSuccess">
          <i class="fa fa-check-circle status-icon--md"></i>
        </ng-container>
      </span>
      <div class="status-message text-alignment">
        <span class="status-header">Status</span>
        <div class="status-content">{{ statusDisplayMessage }} {{ statusResolutionMessage }}</div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="netExchangeViews != null && !isRCRFLOW">
    <div class="rcr-exchange-error padding-top-none">
      <div class="bonds-to-fannie-mae">
        <h4>Bonds to be Distributed to Fannie Mae</h4>
        <div class="table-responsive rcr-exchange-error-table--overflow">
          <table class="table">
            <thead>
              <tr>
                <th>CLASS/POOL</th>
                <th>CUSIP</th>
                <th class="text-currency-align">ORIGINAL BALANCE EXCHANGED</th>
                <th class="text-currency-align">CURRENT BALANCE EXCHANGED</th>
                <th class="text-currency-align">INTEREST RATE/COUPON</th>
                <th class="text-currency-align">ANNUAL INTEREST</th>
              </tr>
            </thead>
            <tbody
              *ngFor="let netExchangeView of netExchangeViews; trackBy: trackByIdentity"
              id="bondsToFannie"
            >
              <tr
                *ngFor="
                  let bond of netExchangeView.netToFNMA;
                  let index = index;
                  trackBy: trackByIdentity
                "
              >
                <td>{{ bond.bondClass }}</td>
                <td>{{ bond.cusip }}</td>
                <td class="text-currency-align">
                  {{ bond.origFace | currency: 'USD' : 'symbol' : '1.0-2' }}
                </td>
                <td class="text-currency-align">
                  {{ bond.currentFace | currency: 'USD' : 'symbol' : '1.2-2' }}
                </td>
                <td class="text-currency-align">{{ bond.interestRate | number: '1.5-5' }}</td>
                <td class="text-currency-align">
                  {{ bond.annualInterest | currency: 'USD' : 'symbol' : '1.2-2' }}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 offset-lg-7">
              <div class="col-lg-3" id="totalToFannieCurrentFace">
                <span class="bonds-total">Total:</span>
                <span
                  class="bonds-total-interest"
                  [ngClass]="{ 'principal-mismatch-error': principalMismatch }"
                  >{{
                    netExchangeViews[0]['totalPrincipalToFNMA']
                      | currency: 'USD' : 'symbol' : '1.2-2'
                  }}</span
                >
              </div>
              <div class="col-lg-3" id="totalToFannieannualInterest">
                <span class="bonds-total">Total:</span>
                <span
                  class="bonds-total-interest"
                  [ngClass]="{ 'principal-mismatch-error': interestMismatch }"
                  >{{
                    netExchangeViews[0]['totalInterestToFNMA']
                      | currency: 'USD' : 'symbol' : '1.2-2'
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bonds-to-dealer">
        <h4>Bonds to be Received</h4>
        <div class="table-responsive rcr-exchange-error-table--overflow">
          <table class="table">
            <thead>
              <tr>
                <th>CLASS/POOL</th>
                <th>CUSIP</th>
                <th class="text-currency-align">ORIGINAL BALANCE EXCHANGED</th>
                <th class="text-currency-align">CURRENT BALANCE EXCHANGED</th>
                <th class="text-currency-align">INTEREST RATE/COUPON</th>
                <th class="text-currency-align">ANNUAL INTEREST</th>
              </tr>
            </thead>
            <tbody
              *ngFor="let netExchangeView of netExchangeViews; trackBy: trackByIdentity"
              id="bondsToRecieve"
            >
              <tr
                *ngFor="
                  let bond of netExchangeView.netToDealer;
                  let index = index;
                  trackBy: trackByIdentity
                "
              >
                <td>{{ bond.bondClass }}</td>
                <td>{{ bond.cusip }}</td>
                <td class="text-currency-align">
                  {{ bond.origFace | currency: 'USD' : 'symbol' : '1.0-2' }}
                </td>
                <td class="text-currency-align">
                  {{ bond.currentFace | currency: 'USD' : 'symbol' : '1.2-2' }}
                </td>
                <td class="text-currency-align">{{ bond.interestRate | number: '1.5-5' }}</td>
                <td class="text-currency-align">
                  {{ bond.annualInterest | currency: 'USD' : 'symbol' : '1.2-2' }}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 offset-lg-7">
              <div class="col-lg-3" id="totalToRecieveCurrentFace">
                <span class="bonds-total">Total:</span>
                <span
                  class="bonds-total-interest"
                  [ngClass]="{ 'principal-mismatch-error': principalMismatch }"
                  >{{
                    netExchangeViews[0]['totalPrincipalToDealer']
                      | currency: 'USD' : 'symbol' : '1.2-2'
                  }}</span
                >
              </div>
              <div class="col-lg-3" id="totalToRecieveannualInterest">
                <span class="bonds-total">Total:</span>
                <span
                  class="bonds-total-interest"
                  [ngClass]="{ 'principal-mismatch-error': interestMismatch }"
                  >{{
                    netExchangeViews[0]['totalInterestToDealer']
                      | currency: 'USD' : 'symbol' : '1.2-2'
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="SMBSFlowModifyExchange">
        <div class="col-lg-4 offset-lg-8 total-fees">
          <button type="button" (click)="onButtonClicked(true)">Modify Exchange</button>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- remove auto calculation and dispaly errors -->

  <ng-container *ngIf="isRCRFLOW">
    <div class="rcr-exchange-error-non-smbs padding-top-none">
      <div class="message-container message-container--error" *ngIf="modalHasStatusError">
        <span class="status-icon">
          <i class="fa fa-ban status-icon--md"></i>
        </span>
        <div class="status-message">
          <span class="status-header">Status</span>
          <div class="status-content">{{ statusDisplayMessage }} {{ statusResolutionMessage }}</div>
        </div>
      </div>

      <ng-container *ngIf="!modalHasStatusError">
        <div class="row row-balance-error modifyExchange">
          <div class="col-sm-12 col-md-8 col-lg-8">
            <h3 class="balanceError">
              Balance Errors
              <i
                id="left-arrow"
                class="fa fa-caret-left decrementArrow"
                [ngClass]="{ disableDecrement: errorCountVal <= 1 }"
                (click)="showRecombination('decrement')"
              ></i>
              {{ errorCountVal }} of {{ totalErrorCount }}
              <i
                id="right-arrow"
                class="fa fa-caret-right incrementArrow"
                [ngClass]="{ disableIncrement: errorCountVal >= totalErrorCount }"
                (click)="showRecombination('increment')"
              ></i>
            </h3>
          </div>

          <div class="col-sm-12 col-md-4 col-lg-4">
            <button
              type="button"
              class="button fm-primary-button modifyExchangeButton"
              (click)="onButtonClicked(true)"
            >
              Modify Exchange
            </button>
          </div>
        </div>

        <div
          *ngFor="
            let netExchangeViewList of rcrCalcFeeErrorRes['netExchangeViews'];
            let i = index;
            trackBy: trackByIdentity
          "
        >
          <ng-container *ngIf="i === recomNumber">
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <p class="recombinationNo">
                  Recombination {{ netExchangeViewList.recombinationNumber }}
                </p>
              </div>
            </div>

            <div class="message-container message-container--error">
              <span class="status-icon">
                <i class="fa fa-ban status-icon--md"></i>
              </span>
              <div class="status-message">
                <span class="status-header">Status</span>
                <div class="status-content">
                  {{ netExchangeViewList.displayMessage }} {{ netExchangeViewList.resolution }}
                </div>
              </div>
            </div>
            <div class="bonds-to-fannie-mae">
              <h4>Bonds to be Distributed to Fannie Mae</h4>
              <div class="table-responsive rcr-exchange-error-table--overflow">
                <table class="table">
                  <thead>
                    <tr>
                      <th>CLASS/POOL</th>
                      <th>CUSIP</th>
                      <th class="text-currency-align">ORIGINAL BALANCE EXCHANGED</th>
                      <th class="text-currency-align">INTEREST RATE/COUPON</th>
                      <th class="text-currency-align">CURRENT BALANCE EXCHANGED</th>
                      <th class="text-currency-align" *ngIf="rcrRemicDealType !== 'SMBS'">
                        MONTHLY INTEREST
                      </th>
                      <th class="text-currency-align" *ngIf="rcrRemicDealType === 'SMBS'">
                        ANNUAL INTEREST
                      </th>
                    </tr>
                  </thead>
                  <tbody id="bondsToFannie">
                    <tr
                      *ngFor="
                        let bond of netExchangeViewList.netToFNMA;
                        let index = index;
                        trackBy: trackByIdentity
                      "
                    >
                      <td>{{ bond.bondClass }}</td>
                      <td>{{ bond.cusip }}</td>
                      <td class="text-currency-align">
                        {{ bond.origFace | currency: 'USD' : 'symbol' : '1.0-2' }}
                      </td>
                      <td class="text-currency-align">{{ bond.interestRate | number: '1.5-5' }}</td>
                      <td class="text-currency-align">
                        {{ bond.currentFace | currency: 'USD' : 'symbol' : '1.2-2' }}
                      </td>
                      <td class="text-currency-align" *ngIf="rcrRemicDealType !== 'SMBS'">
                        {{ bond.monthlyInterest | currency: 'USD' : 'symbol' : '1.2-2' }}
                      </td>
                      <td class="text-currency-align" *ngIf="rcrRemicDealType === 'SMBS'">
                        {{ bond.annualInterest | currency: 'USD' : 'symbol' : '1.2-2' }}
                      </td>
                    </tr>
                  </tbody>

                  <tbody class="error-highlight-tbody">
                    <tr>
                      <td class="error-highlight"></td>
                      <td class="error-highlight"></td>
                      <td class="error-highlight"></td>
                      <td class="error-highlight"></td>
                      <td
                        class="error-highlight total-amount text-currency-align"
                        id="totalToFannieCurrentFace"
                        [ngClass]="{
                          'total-amount-interest-mismatch':
                            netExchangeViewList['validationStatus'] === 'INTEREST_MISMATCH',
                        }"
                      >
                        <span class="bonds-total">Total:</span>
                        <span
                          class="bonds-total-interest"
                          [ngClass]="{ 'principal-mismatch-error': principalMismatch }"
                          >{{
                            netExchangeViewList['totalPrincipalToFNMA']
                              | currency: 'USD' : 'symbol' : '1.2-2'
                          }}</span
                        >
                      </td>
                      <td
                        class="error-highlight total-amount text-currency-align"
                        id="totalToFannieannualInterest"
                      >
                        <span class="bonds-total">Total:</span>
                        <span
                          class="bonds-total-interest"
                          [ngClass]="{ 'principal-mismatch-error': interestMismatch }"
                          *ngIf="rcrRemicDealType !== 'SMBS'"
                          >{{
                            netExchangeViewList['totalMonthlyInterestToFNMA']
                              | currency: 'USD' : 'symbol' : '1.2-2'
                          }}</span
                        >
                        <span
                          class="bonds-total-interest"
                          [ngClass]="{ 'principal-mismatch-error': interestMismatch }"
                          *ngIf="rcrRemicDealType === 'SMBS'"
                          >{{
                            netExchangeViewList['totalInterestToFNMA']
                              | currency: 'USD' : 'symbol' : '1.2-2'
                          }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="bonds-to-dealer">
              <h4>Bonds to be Distributed to Dealer</h4>
              <div class="table-responsive rcr-exchange-error-table--overflow">
                <table class="table">
                  <thead>
                    <tr>
                      <th>CLASS/POOL</th>
                      <th>CUSIP</th>
                      <th class="text-currency-align">ORIGINAL BALANCE EXCHANGED</th>
                      <th class="text-currency-align">INTEREST RATE/COUPON</th>
                      <th class="text-currency-align">CURRENT BALANCE EXCHANGED</th>
                      <th class="text-currency-align" *ngIf="rcrRemicDealType !== 'SMBS'">
                        MONTHLY INTEREST
                      </th>
                      <th class="text-currency-align" *ngIf="rcrRemicDealType === 'SMBS'">
                        ANNUAL INTEREST
                      </th>
                    </tr>
                  </thead>
                  <tbody id="bondsToRecieve">
                    <tr
                      *ngFor="
                        let bond of netExchangeViewList.netToDealer;
                        let index = index;
                        trackBy: trackByIdentity
                      "
                    >
                      <td>{{ bond.bondClass }}</td>
                      <td>{{ bond.cusip }}</td>
                      <td class="text-currency-align">
                        {{ bond.origFace | currency: 'USD' : 'symbol' : '1.0-2' }}
                      </td>
                      <td class="text-currency-align">{{ bond.interestRate | number: '1.5-5' }}</td>
                      <td class="text-currency-align">
                        {{ bond.currentFace | currency: 'USD' : 'symbol' : '1.2-2' }}
                      </td>
                      <td class="text-currency-align" *ngIf="rcrRemicDealType !== 'SMBS'">
                        {{ bond.monthlyInterest | currency: 'USD' : 'symbol' : '1.2-2' }}
                      </td>
                      <td class="text-currency-align" *ngIf="rcrRemicDealType === 'SMBS'">
                        {{ bond.annualInterest | currency: 'USD' : 'symbol' : '1.2-2' }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody class="error-highlight-tbody">
                    <tr>
                      <td class="error-highlight"></td>
                      <td class="error-highlight"></td>
                      <td class="error-highlight"></td>
                      <td class="error-highlight"></td>
                      <td
                        class="error-highlight total-amount text-currency-align"
                        id="totalToRecieveCurrentFace"
                        [ngClass]="{
                          'total-amount-interest-mismatch':
                            netExchangeViewList['validationStatus'] === 'INTEREST_MISMATCH',
                        }"
                      >
                        <span class="bonds-total">Total:</span>
                        <span
                          class="bonds-total-interest"
                          [ngClass]="{ 'principal-mismatch-error': principalMismatch }"
                          >{{
                            netExchangeViewList['totalPrincipalToDealer']
                              | currency: 'USD' : 'symbol' : '1.2-2'
                          }}</span
                        >
                      </td>
                      <td
                        class="error-highlight total-amount text-currency-align"
                        id="totalToRecieveannualInterest"
                      >
                        <span class="bonds-total">Total:</span>
                        <span
                          class="bonds-total-interest"
                          [ngClass]="{ 'principal-mismatch-error': interestMismatch }"
                          *ngIf="rcrRemicDealType !== 'SMBS'"
                          >{{
                            netExchangeViewList['totalMonthlyInterestToDealer']
                              | currency: 'USD' : 'symbol' : '1.2-2'
                          }}</span
                        >
                        <span
                          class="bonds-total-interest"
                          [ngClass]="{ 'principal-mismatch-error': interestMismatch }"
                          *ngIf="rcrRemicDealType === 'SMBS'"
                          >{{
                            netExchangeViewList['totalInterestToDealer']
                              | currency: 'USD' : 'symbol' : '1.2-2'
                          }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
